import { useQuery } from '@tanstack/react-query';

import { getPricing } from '@/features/subscriptions/api/get-pricing';

export const PRICING_QUERY_KEY = 'pricing';

export function usePricing() {
  return useQuery({
    queryKey: [PRICING_QUERY_KEY],
    queryFn: getPricing,
    staleTime: 60 * 60 * 1000, // Cache for 1 hour (prices don't change often)
    gcTime: 2 * 60 * 60 * 1000, // Keep in cache for 2 hours
  });
}
